/**
 * Hook used to attach click event handlers to the tcpa element.
 */

import { TCPA } from "@lgp/shared/constants";
import { useCallback } from "react";

const useTcpaOnClickEventListener = function useTcpaOnClickEventListener(
  targetOrigin
) {
  // Handle the TCPA link clicks.
  const onClick = useCallback(
    function onClick(e) {
      const el = e.target || e.currentTarget;
      if (
        el &&
        el.tagName.toLowerCase() === "a" &&
        (el.href.indexOf(TCPA.TCPA_S3_DIRNAME) > -1 ||
          el.href.indexOf("privacy-policy") > -1 ||
          el.href.indexOf("consumer-tos") > -1)
      ) {
        e.preventDefault();
        window.top.postMessage(
          {
            action: "lgp:tcpa:open",
            payload: {
              url: el.href,
            },
          },
          targetOrigin
        );
      }
    },
    [targetOrigin]
  );

  return onClick;
};

export default useTcpaOnClickEventListener;
